export const PER_PAGE_PROPERTY_DETAIL = 'PER_PAGE_PROPERTY_DETAIL'
export const PAGE_PROPERTY_DETAIL = 'PAGE_PROPERTY_DETAIL'
export const PAGES_PROPERTY_DETAIL = 'PAGES_PROPERTY_DETAIL'
export const IS_LOADING_TABLE_PROPERTY_DETAIL = 'IS_LOADING_TABLE_PROPERTY_DETAIL'
export const ARRAY_LIST_ALBUMS_TYPES_PROPERTY_DETAIL = 'ARRAY_LIST_ALBUMS_TYPES_PROPERTY_DETAIL'
export const ARRAY_LIST_ALBUMS_TYPES_FILES_PROPERTY_DETAIL = 'ARRAY_LIST_ALBUMS_TYPES_FILES_PROPERTY_DETAIL'
export const FORM_DATA_PROPERTY_DETAIL = 'FORM_DATA_PROPERTY_DETAIL'
